<template>
  <v-card class="elevation-7 print-card" :class="{'mobile-card': $vuetify.breakpoint.xsOnly}">
    <v-toolbar class="toolbar4 white--text remove-space-on-print">
      <v-toolbar-title>Dados do Selo</v-toolbar-title>
    </v-toolbar>
    <v-divider light></v-divider>
    <v-layout align-start row wrap class="remove-space-on-print">

      <v-flex xs4 :class="{'pt-0': $vuetify.breakpoint.name === 'sm'}">
        <v-card-text class="fix-margin-print">
          <qr-code :text="url.href" class="hide-on-print" :size="150"></qr-code>
          <qr-code :text="url.href" class="show-on-print" :size="100"></qr-code>
        </v-card-text>
      </v-flex>

      <v-flex xs4 :class="{'pt-0': $vuetify.breakpoint.name === 'sm'}">
        <v-card-text class="fix-margin-print">
          <div>
            <div>Número do selo:</div>
            <div><b :class="$vuetify.breakpoint.name">{{codigoSelo}}</b></div>

            <div>Tipo do selo:</div>
            <div><b :class="$vuetify.breakpoint.name">{{selo.tipoSelo.descricao}} - {{selo.tipoSelo.cor}}</b></div>
            <div>Número do pedido:</div>
            <div><b :class="$vuetify.breakpoint.name">{{selo.pedidoSelo.pedido}}</b></div>
            <div v-if="selo.estadoSelo != 'ANTIGO'">
              <div>Status do Selo:</div>
              <div class="inline"><b :class="$vuetify.breakpoint.name">{{selo.estadoSelo}}</b></div>
            </div>
          </div>
        </v-card-text>
      </v-flex>

      <v-flex xs4 :class="{'pt-0': $vuetify.breakpoint.name === 'sm'}">
        <v-card-title class="fix-margin-print">
          <div>
            <div>Data do pedido:</div>
            <div><b :class="$vuetify.breakpoint.name">{{dataFormatada(selo.pedidoSelo.dataPedido)}}</b></div>

            <div>Data de entrega do pedido:</div>
              <div v-if="selo.pedidoSelo.dataEntregaPedido"><b :class="$vuetify.breakpoint.name">{{dataFormatada(selo.pedidoSelo.dataEntregaPedido)}}</b></div>
              <div v-if="!selo.pedidoSelo.dataEntregaPedido"><b :class="$vuetify.breakpoint.name">Não Informada</b></div>
          </div>
        </v-card-title>
      </v-flex>

    </v-layout>

    <v-layout v-if="selo.estadoSelo == 'ANTIGO'" align-start row wrap class="remove-space-on-print">
      <v-card-text class="fix-margin-print">
        <div>Status do Selo:</div>
        <div>
          <div class="inline"><b :class="$vuetify.breakpoint.name">{{selo.estadoSelo}}</b></div>
          <div class="inline"><b :class="$vuetify.breakpoint.name"> - ANTERIOR À IMPLANTAÇÃO DO SIGEXTRA</b></div>
          <div>
            <div>Sistema implatado no Registro Civis das Pessoas Naturais e Tabelionato de Notas, em 01/08/2011, e para os Serviços Únicos, Registros de Imóveis, Títulos e Documentos, Civis das Pessoas Jurídicas e Tabelionato de Protestos de Títulos e Documentos, em 01/04/2012.</div>
          </div>
        </div>
      </v-card-text>
    </v-layout>

  </v-card>
</template>

<script>
  import Selo from "../../domain/selo/selo";
  import VueQRCodeComponent from 'vue-qrcode-component'

  export default {
    name: "DadosSeloCard",
    props: {
      selo: {
        type: Selo,
        required: true
      },
    },
    components: {
      'qr-code': VueQRCodeComponent
    },
    data: function () {
      return {
        url: window.location
      };
    },
    computed: {
      codigoSelo: function () {
        return this.selo.isDigital() ? `${this.selo.numero}-${this.selo.chave}` : this.selo.numero;
      },
      labelClass: function () {
        const classe = this.selo.isDigital() ? 'digital' : 'fisico';
        return `label-${classe}`;
      },
      imgClass: function () {
        const classe = this.selo.isDigital() ? 'digital' : 'fisico';
        return `img-${classe}`;
      },
    },
    methods: {}
  }
</script>

<style scoped>

  .inline {
    display: inline;
  }

  .toolbar4 {
    background: #161D40;
  }

</style>



// WEBPACK FOOTER //
// src/components/detalhes/DadosSeloCard.vue